export default __webpack_public_path__ + "static/media/background-1.92640a28.png";